import React from 'react';
import { Outlet } from 'react-router-dom';
import { SiteHeader, SiteFooter } from '../components/PublicChrome';
const PublicLayout: React.FC = () => <div className="hk-landing hk-public"><a className="hk-skip" href="#public-main">Skip to content</a><SiteHeader /><main id="public-main"><Outlet /></main><SiteFooter /></div>;
export default PublicLayout;
